import { ShiftInviteStatus } from "../type";

/**
 * Resolves the invite status to display. A `PENDING` invite whose `expiresAt` has
 * already passed is treated as `EXPIRED` so surfaces don't show a stale countdown
 * before the backend flips the status. All other statuses pass through unchanged.
 */
export function getEffectiveInviteStatus(
  status: ShiftInviteStatus,
  expiresAt: Date,
  now: Date = new Date()
): ShiftInviteStatus {
  if (status === ShiftInviteStatus.PENDING && expiresAt.getTime() <= now.getTime()) {
    return ShiftInviteStatus.EXPIRED;
  }

  return status;
}
